module.exports = __webpack_public_path__ + "media/svg/icon_question_mark-f4dbeead.svg";